// removed by extract-text-webpack-plugin
module.exports = {"status-messages":"StatusMessages__status-messages___3IcLZ","message":"StatusMessages__message___1OfxM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StatusMessages/StatusMessages.css
// module id = 711
// module chunks = 0